
import Snapchat from "../../../assets/filled/Snapchat.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function SnapchatIcon({ className, dataTestid = "SnapchatIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Snapchat data-testid={dataTestid} className={classes} {...rest} />
  );
}
